import styled from 'styled-components'

const RachunekPrzeplywowStyle = styled.div`
  grid-area: main;
  background-color: ${props => props.theme.black4};
  padding: 0 12px 12px;

  .checkbox-label {
    height: 24px;
  }

  .additional-checkbox {
    height: 24px;
    margin: 0;
  }

  .container {
    height: 80vh;
  }

  .list {
    overflow: auto;
    height: 72vh;
  }
`
export default RachunekPrzeplywowStyle
